import { currencyColumn, dateColumn, numberColumn, primaryRelationshipColumn, relationshipColumn, textColumn } from "@api/schema/columnHelpers";
import { objectDefinition } from "@api/schema/supportedObjects";
import RapidReinvestmentSection from "./RapidReinvestmentSection";
import { forwardRef } from "react";
import { Box, Typography } from "@mui/joy";

const Overview = forwardRef(function Overview(props, ref) {
    return (
        <RapidReinvestmentSection
            type={'default'}
            columns={[]}
            {...props}
            ref={ref}
        >
            <Box sx={{px: 1, pt: 1.5, pb: 2, display: 'flex', flexDirection: 'column', gap: 2}}>
                <Typography fontSize={'md'}>
                Introducing <b><em>Rapid Reinvestment</em></b>—the latest feature in Maestro Community Manager designed to streamline and supercharge your community’s revitalization efforts. This powerful tool allows you to input all the critical information your organization needs from one easy-to-use screen. Whether you're tracking new or closed businesses, employee changes, grants received, events, and trainings held, or documenting public improvements and investments, <em>Rapid Reinvestment</em> puts everything at your fingertips.
                </Typography>

                <Typography fontSize={'md'}>
                You can also effortlessly log property sales, new properties, and other key community developments, all in one place. By consolidating these essential functions, <em>Rapid Reinvestment</em> reduces data entry time and enhances accuracy, making it easier for you to stay on top of changes and opportunities in your community.
                </Typography>

                <Typography fontSize={'md'}>
                Designed with efficiency and ease of use in mind, this feature empowers your team to focus on driving real impact while maintaining a comprehensive, up-to-date snapshot of your community’s economic health and progress.
                </Typography>

                <Typography fontSize={'md'}>
                Fill out all applicable information for each section. Press the "Next" button to move on will mark the current section as complete.
                </Typography>
            </Box>
        </RapidReinvestmentSection>
    )
});

export {Overview};
